/* eslint-disable import/no-unresolved */
import ReportConfigDetails from 'views/Rules/common/ReportConfigDetails';

const FFIEC041ReportConfigDetails = ({
    selectedFFIEC041Quarter, setSelectedFFIEC041Quarter, summaryQuartersFFIEC041Data, commonFFIEC041Data,
}) => (
    <ReportConfigDetails
        selectedQuarter={selectedFFIEC041Quarter}
        setSelectedQuarter={setSelectedFFIEC041Quarter}
        summaryQuartersData={summaryQuartersFFIEC041Data}
        commonData={commonFFIEC041Data}
        displayColumn="Yes"
        istopier="No"
        rule="FFIEC041"
    />
);

export default FFIEC041ReportConfigDetails;
